const READY_STATUS_LABEL = "À jour";
const STALE_STATUS_LABEL = "Périmé";

const READY_STATUSES = new Set([
  "current",
  "fresh",
  "ready",
  "synchronized",
  "synced",
]);

const STALE_STATUSES = new Set([
  "expired",
  "outdated",
  "stale",
]);

const REVIEW_REQUIRED_STATUSES = new Set([
  "action_required",
  "pending_review",
  "requires_review",
  "review_required",
]);

const CONFIRMATION_REQUIRED_STATUSES = new Set([
  "confirm_required",
  "confirmation_required",
  "pending_confirmation",
  "requires_confirmation",
]);

function normalizeOptimizationStatus(status) {
  return typeof status === "string"
    ? status.trim().toLowerCase()
    : "";
}

export function resolveOptimizationStatusPresentation(status, { hasOptimization = true } = {}) {
  const normalizedStatus = normalizeOptimizationStatus(status);

  if (CONFIRMATION_REQUIRED_STATUSES.has(normalizedStatus)) {
    return {
      detail: "Une validation utilisateur est nécessaire avant d’appliquer les changements.",
      label: "Confirmation requise",
      tone: "warning",
    };
  }

  if (REVIEW_REQUIRED_STATUSES.has(normalizedStatus)) {
    return {
      detail: "Les résultats nécessitent une vérification avant de poursuivre.",
      label: "À vérifier",
      tone: "warning",
    };
  }

  if (STALE_STATUSES.has(normalizedStatus)) {
    return {
      detail: "Les résultats affichés ne correspondent plus exactement aux fichiers importés.",
      label: STALE_STATUS_LABEL,
      tone: "warning",
    };
  }

  if (READY_STATUSES.has(normalizedStatus) || (hasOptimization && !normalizedStatus)) {
    return {
      detail: "Les résultats affichés correspondent aux dernières données optimisées.",
      label: READY_STATUS_LABEL,
      tone: "success",
    };
  }

  if (!hasOptimization) {
    return {
      detail: "L’optimisation doit être lancée pour produire des résultats exploitables.",
      label: "Aucune optimisation disponible",
      tone: "neutral",
    };
  }

  return {
    detail: "Les résultats nécessitent une vérification avant de poursuivre.",
    label: "À vérifier",
    tone: "warning",
  };
}